import { apiHelper, getApiBaseUrl } from '../utils/apiHelper';

// const API_URL = `${process.env.REACT_APP_API_URL}/api/org/page`;
const API_URL = `${getApiBaseUrl()}/api/org/page`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchPages = (payload) => apiHelper(API_URL, 'GET', payload);
export const createPage = (payload) => apiHelper(API_URL, 'POST', payload, headers);
export const fetchPage = (pageId) => apiHelper(`${API_URL}/${pageId}`, 'GET');
export const modifyPage = (payload) => apiHelper(`${API_URL}/${payload.get('id')}`, 'POST', payload, headers);
export const deletePageApi = (pageId) => apiHelper(`${API_URL}/${pageId}`, 'DELETE');
export const changeStatus = (pageId) => apiHelper(`${API_URL}/change-status/${pageId}`, 'POST');

